<template>
    <b-card
            class="loading-placeholder"
            :style="{
                width: width,
                height: height,
            }"
    />
</template>

<script>
    export default {
        name: 'CardLoadingPlaceholder',
        props: {
            width: {
                type: [String, Number],
                required: false,
                default: 'auto',
            },
            height: {
                type: [String, Number],
                required: false,
                default: 'auto',
            }
        }
    };
</script>
